import React, { useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import SubmitButton from "components/common/SubmitButton";

const EditForm = ({ type, item, onSubmit, cancelEdit, fields, title }) => {
  const ADD_NEW = type === "addNew";
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const defaultValidator = (values) => {
    const errors = {};
    fields?.forEach((f) => {
      if (!f?.validationMessage) return;
      const v = values?.[f.name];
      const isEmpty =
        v === undefined ||
        v === null ||
        (typeof v === "string" && v.trim() === "");
      if (isEmpty) errors[f.name] = f.validationMessage;
    });
    return errors;
  };

  const prepareInitialValues = (initialItem) => {
    if (!initialItem) return {};
    const prepared = { ...initialItem };

    if (prepared.rowStyle) {
      if (typeof prepared.rowStyle === "string") {
        if (prepared.rowStyle.includes("background:'none'") || prepared.rowStyle.includes('background:"none"')) {
          prepared.rowStyle = 'none';
        }
        else {
          const match = prepared.rowStyle.match(/backgroundColor:['"]([^'"]+)['"]/);
          if (match && match[1]) {
            prepared.rowStyle = match[1];
          } else if (prepared.rowStyle.startsWith('#')) {
          } else {
            prepared.rowStyle = 'none';
          }
        }
      } else {
        prepared.rowStyle = 'none';
      }
    } else {
      prepared.rowStyle = 'none';
    }

    return prepared;
  };

  const handleSubmit = async (values) => {
    const submission = { ...values };

    if (submission.rowStyle !== undefined) {
      if (submission.rowStyle && submission.rowStyle.trim() && submission.rowStyle !== 'none') {
        submission.rowStyle = `{backgroundColor:'${submission.rowStyle}'}`;
      } else {
        submission.rowStyle = `{background:'none'}`;
      }
    }

    setIsSubmitting(true);
    try {
      await onSubmit?.(submission);
    } finally {
      setIsSubmitting(false);
    }
  };

  const initialValues = prepareInitialValues(item);

  const isCheckbox = (field) => field.type === "checkbox";

  return (
    <Dialog
      title={ADD_NEW ? `Add ${title}` : `Edit ${item?.name}`}
      onClose={cancelEdit}
      width={600}
    >
      <Form
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validator={defaultValidator}
        render={(formRenderProps) => (
          <>
            <FormElement style={{ maxWidth: 1200 }}>
              <fieldset className="p-3 ps-4">
                {fields
                  .filter((f) => !(ADD_NEW && f.name === "active"))
                  .map((field) => {
                    const error =
                      isSubmitted && formRenderProps?.errors?.[field.name];

                    return (
                      <div
                        key={field.name}
                        className={`mb-2 ${isCheckbox(field)
                          ? "d-inline-flex align-items-center mt-1 me-3"
                          : ""
                          }`}
                      >
                        {!isCheckbox(field) && (
                          <Label className="label my-1 w-100">
                            {field.label}
                          </Label>
                        )}

                        <Field
                          name={field.name}
                          component={field.component}
                          defaultChecked={field.defaultChecked}
                          defaultValue={field.defaultValue}
                          label={isCheckbox(field) ? field.label : null}
                        />

                        {error && (
                          <div className="fs-sm my-1 text-danger">
                            <i>{error}</i>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </fieldset>
            </FormElement>

            <div className="dialog-footer">
              <button
                className="bgBtnSecondary common-btn me-2"
                onClick={cancelEdit}
                type="button"
              >
                Cancel
              </button>
              <SubmitButton
                className="me-3"
                onClick={() => {
                  setIsSubmitted(true);
                  formRenderProps.onSubmit();
                }}
                isLoading={isSubmitting}
                disabled={!formRenderProps.allowSubmit}
              >
                {ADD_NEW ? "Save" : "Update"}
              </SubmitButton>
            </div>
          </>
        )}
      />
    </Dialog>
  );
};

export default EditForm;
